import { ShieldAlert } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Standard notice on legal templates (§7.11): these are templates to be
 * reviewed by a lawyer, never presented as final legal advice.
 */
export function LegalNotice({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "flex items-start gap-3 rounded-xl border border-warning/40 bg-warning/10 p-4 text-sm text-foreground",
        className,
      )}
    >
      <ShieldAlert
        className="mt-0.5 size-5 shrink-0 text-warning"
        strokeWidth={1.5}
        aria-hidden
      />
      <p>
        This is a template to be reviewed by a qualified lawyer before launch.
        It is not legal advice.
      </p>
    </div>
  );
}
